import React from 'react';
import { css } from '@emotion/react';
import { color } from '../../../../styles';
import { IGetDfreeBDeviceAnalyticsResult } from '../../../../types/api/traversal/getDfreeBDeviceAnalytics';
import { TimeDisplay } from './timeDisplay';
import { useTranslation } from 'react-i18next';

interface Props {
  termNotification: IGetDfreeBDeviceAnalyticsResult['termNotification'];
}

const Container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
  border-radius: 8px;
  border: 1px solid ${color.border_gray};
  background: ${color.light_gray};
`;

const GraphTitle = css`
  max-width: 450px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
`;

const AverageTimeContainer = css`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid ${color.border_gray};
  width: 100%;
  max-width: 480px;
  border-radius: 8px;
  padding: 16px;
  gap: 2px;
`;

const CounterText = css`
  margin-left: '8px';
  font-size: 24px;
  font-weight: bold;
`;

export const DefecationTimeFromNotification: React.FC<Props> = ({ termNotification }) => {
  const { t, i18n } = useTranslation();
  return (
    <div css={Container}>
      <div css={GraphTitle}>{t('timeFromNotificationToFirstBowelMovement', '通知時間から初回排便の時間')}</div>
      <div css={AverageTimeContainer}>
        <TimeDisplay minutes={termNotification.minutes} />
        {termNotification.count > 0 && (
          <span css={CounterText}>
            （{t('Total', '全')}
            {i18n.language.startsWith('ja') ? '' : ' '}
            {termNotification.count}
            {i18n.language.startsWith('ja') ? '' : ' '}
            {t('times', '回')}）
          </span>
        )}
      </div>
    </div>
  );
};
